// https://github.com/jquery/jquery/issues/2871#issuecomment-497963776
jQuery.event.special.touchstart = {
  setup: function( _, ns, handle ){
    this.addEventListener("touchstart", handle, { passive: true });
  }
};
